export { default as App } from './App'
export { default as Main } from './Main'
export { default as Login } from './Login'
export { default as LoginCreatePassword } from './LoginCreatePassword'
export { default as LoginResetPasswordRequest } from './LoginResetPasswordRequest'
export { DeductionDetail, DeductionProgress } from './Deductions'
export { default as UnsupportedBrowser } from './UnsupportedBrowser'
export { default as RedirectNotice } from './RedirectNotice'
// main routes
export { default as Accounts } from './Accounts'
export { default as Case } from './Case'
export { default as CaseList } from './CaseList'
export { default as Communications } from './Communications'
export { default as CreditApplication } from './CreditApplication'
export { default as CreditApplications } from './CreditApplications'
export { default as CreditList } from './CreditList'
export { default as CreditProductDetail } from './CreditProductDetail'
export { default as Dashboard } from './Dashboard'
export { default as Deduction } from './Deduction'
export { default as Deductions } from './Deductions'
export { default as DeductionsInternal } from './DeductionsInternal'
export { default as Division } from './Division'
export { default as DownloadList } from './Downloads'
export { default as Files } from './Files'
export { default as FileProcess } from './FileProcess'
export { default as FilesUpload } from './FilesUpload'
export { default as Home } from './Home'
export { default as Identity } from './Identity'
export { default as IdentityList } from './IdentityList'
export { default as ImpactReport } from './ImpactReport'
export { default as InsuranceList } from './InsuranceList'
export { default as InsuranceProductDetail } from './InsuranceProductDetail'
export { default as InvestmentList } from './InvestmentList'
export { default as InvestmentProductDetail } from './InvestmentProductDetail'
export { default as WithdrawalList } from './WithdrawalList'
export { default as WithdrawalBatchList } from './WithdrawalBatchList'
export { default as LoanApplication } from './LoanApplication'
export { default as Metrics } from './Metrics'
export { default as ObjectRedirect } from './ObjectRedirect'
export { default as Payment } from './Payment'
export { default as Payments } from './Payments'
export { default as PayrollRun } from './PayrollRun'
export { default as PayrollRunList } from './PayrollRunList'
export { default as Request } from './Request'
export { default as Requests } from './Requests'
export { default as Search } from './Search'
export { default as TaskList } from './TaskList'
export { default as Transaction } from './Transaction'
export { default as Transactions } from './Transactions'
export { default as WhatsAppMessage } from './WhatsAppMessage'
export { default as Workflow } from './Workflow'
export { default as WorkflowList } from './WorkflowList'
export { default as EmployerRelatedMessages } from './EmployerRelatedMessages'
export { default as WithdrawalDetail } from './WithdrawalDetail'
export { default as WithdrawalBatchDetail } from './WithdrawalBatchDetail'



// WEBPACK FOOTER //
// ./src/containers/index.js